/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import { Link } from '@mui/material'
import { Fragment, ReactElement } from 'react';
import { genJyuuGothicBold } from '../../fonts/FontFace'
import { FeaturedArticlesComponentProp } from '../../types'
import routes from '../../utils/routes'

type Props = {
  component: FeaturedArticlesComponentProp
  key: number
}

function FeaturedArticlesComponent({ component }: Props): ReactElement {
  const titleStyle = css`
    ${genJyuuGothicBold}
    color: ${component.titleColor};
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 0;
    line-height: 30px;
  `

  return (
    <Fragment>
      <div css={featuredArticlesComponentStyle}>
        <h2 css={titleStyle}>過去の特集も合わせてチェック</h2>
        <div css={featuredArticlesWrapperStyle}>
          {component.featuredArticles.map((featuredArticle) => (
            <div css={featuredArticleWrapperStyle} key={featuredArticle.id}>
              <Link
                href={routes.featured_article_path(featuredArticle.id)}
                css={featuredArticleBannerLinkStyle}
              >
                <img css={featuredArticleBannerStyle} src={featuredArticle.appTopBanner?.url} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

const featuredArticlesComponentStyle = css`
  background-color: white;
  padding: 16px 0 0;
  margin-top: 16px;
`

const featuredArticlesWrapperStyle = css`
  padding-bottom: 16px;
  display: flex;
  overflow-x: scroll;
`

const featuredArticleWrapperStyle = css`
  flex-shrink: 0;
  width: 150px;
  margin: 0 8px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
`

const featuredArticleBannerLinkStyle = css`
  width: 100%;
`

const featuredArticleBannerStyle = css`
  width: 100%;
`

export default FeaturedArticlesComponent
